import React from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import styles from "./TeamsActivity.module.scss";
import { PaginatedNewsResponse } from "../../../types/types";
import NewsCard from "../../../components/_shared/news-card/NewsCard";

const TEAM_IDS: Record<"MAN" | "WOMAN", string> = {
  MAN: "50bc1691-dd5a-47fe-be40-678ca1b08348",
  WOMAN: "7accd459-e6e1-48fa-9483-e2b2d02af9f4",
};

type TeamsActivityProps = {
  team: "MAN" | "WOMAN";
};

const TeamsActivity = ({ team }: TeamsActivityProps) => {
  const { t } = useTranslation();

  const { data } = useFetch<PaginatedNewsResponse>(
      `/posts/published?subcategoryId=${TEAM_IDS[team]}`
  );

  if (!data || data.content.length === 0) return null;

  return (
      <div className={styles.MensActivity}>
        <h1>{t("app.home.teamActivity", "Aktivitetet e kombëtares")}</h1>
        <div className={styles.NewsCardContainer}>
          {data.content.slice(0, 3).map((news) => (
              <NewsCard key={news.id} {...news} />
          ))}
        </div>
      </div>
  );
};

export default TeamsActivity;